module.exports = "/_next/static/images/ae75e7ace2a7ff341cad151d240b9f27-credito.svg.webp";